import { Box, Text, Textarea, TextareaProps } from '@tonic-one/react';
import React, { useImperativeHandle, useRef } from 'react';
import { ValidProps } from '../../../../types';
import { InputChildRef } from '../InputWithValid';

export interface TextareaWithValidProps
  extends Omit<TextareaProps, 'onChange'> {
  onChange: (value: string) => void;
  validates: ValidProps[];
  maxLength: number;
  value?: string;
}

export const TextareaWithValid = React.forwardRef<
  Textarea,
  TextareaWithValidProps
>(({ onChange, validates, value, ...rest }, ref) => {
  const [errorMsg, setErrorMsg] = React.useState<string | undefined>(undefined);
  const validate = (value: string) => {
    let isValid = true;
    validates.forEach((valid) => {
      if (!valid.validMethod(value)) {
        isValid = false;
        setErrorMsg(valid.errMsg);
      }
    });
    if (isValid) {
      setErrorMsg(undefined);
    }
  };
  const reset = () => {
    setErrorMsg(undefined);
  };
  const inputRef = useRef<InputChildRef | null>(null);
  useImperativeHandle(
    ref,
    (): {
      errorMsg: string | undefined;
      validate: (value: string) => void;
      reset: () => void;
    } => ({
      // 暴露的属性
      validate,
      errorMsg,
      reset,
    })
  );
  const InlineError = (props: any) => (
    <Text fontSize="sm" lineHeight="sm" color="red:50" {...props} />
  );
  return (
    <Box flexDirection="column">
      <Textarea
        width={360}
        ref={inputRef}
        height={86}
        value={value}
        onChange={(e: any) => {
          validate(e.target.value);
          onChange(e.target.value);
        }}
        {...rest}
      />
      <Box>
        {errorMsg !== undefined && <InlineError>{errorMsg}</InlineError>}
      </Box>
    </Box>
  );
});
